import { _keyBy } from '../../script-utils/keyBy'
import { PurchaseState } from '../Reducers'
import { PurchaseAction, PurchaseActionType } from './PurchaseActions'
import { getPackagePlatformId, getPlayType } from '../../services/UserFeatureService'

const INITIAL_STATE: PurchaseState = {
	paymentsUrl: '',
	paymentsPortalOpen: false,
	loading: false,
	loadingLimits: false,
	loadingBundles: false,
	loadingBundleItems: false,
	submitted: false,
	kycLimitApplicable: false,
	purchaseLimits: [],
	bundleOptions: {
		bundles: [],
		offers: [],
		bonus: [],
	},
	bonusCode: '',
	bundleItems: {},
	hasMadePurchases: false,
}

export const purchaseReducer = (state: PurchaseState = INITIAL_STATE, action: PurchaseAction) => {
	switch (action.type) {
	case PurchaseActionType.SELECT_BUNDLE:
		return { ...state, bundle: action.payload }
	case PurchaseActionType.RESET_PURCHASE:
		return { ...state, bundle: undefined, processingStatus: undefined, provider: undefined, source: undefined }
	case PurchaseActionType.SELECT_PROVIDER:
		return { ...state, provider: action.payload.provider, providerToken: action.payload.token }
	case PurchaseActionType.RESET_PROVIDER:
		return { ...state, provider: undefined }
	case PurchaseActionType.SUBMIT_PURCHASE:
		return { ...state, submitted: true, loading: true }
	case PurchaseActionType.RECEIVE_PAYMENTS_URL:
		return {...state, paymentsUrl: action.payload.url, loading: false, paymentsPortalOpen: true}
	case PurchaseActionType.RECEIVE_PURCHASE_RESPONSE:
		return { ...state, submissionResponse: action.payload.response, submissionError: action.payload.error }
	case PurchaseActionType.SET_SESSION_ID:
		return { ...state, sessionId: action.payload }
	case PurchaseActionType.SET_PROCESSING_STATUS:
		return { ...state, processingStatus: action.payload, paymentsPortalOpen: false }
	case PurchaseActionType.FETCH_PURCHASE_LIMITS:
		const loadingLimits = { ...state, loadingLimits: true }
		return updateLoadingState(loadingLimits)
	case PurchaseActionType.RECEIVE_PURCHASE_LIMITS:
		const loadedLimits = {
			...state,
			kycLimitApplicable: action.payload.kycLimitApplicable,
			loadingLimits: false,
			purchaseLimits: action.payload.purchaseLimits,
		}
		return updateLoadingState(loadedLimits)
	case PurchaseActionType.FETCH_BUNDLES:
		const loadingBundles = { ...state, loadingBundles: true }
		return updateLoadingState(loadingBundles)
	case PurchaseActionType.RECEIVE_BUNDLES:
		const currentSite = getPackagePlatformId()
		const playType = getPlayType()
		action.payload.bundles = action.payload.bundles.filter(b => b.targetSite === currentSite && (b.playType === undefined || b.playType === playType))
		action.payload.offers = action.payload.offers.filter(o => o.targetSite === currentSite && (o.playType === undefined || o.playType === playType))
		action.payload.bonus = action.payload.bonus.filter(b => b.targetSite === currentSite && (b.playType === undefined || b.playType === playType))
		const loadedBundles = { ...state, bundleOptions: action.payload, loadingBundles: false }
		return updateLoadingState(loadedBundles)
	case PurchaseActionType.SET_BONUS_CODE:
		return { ...state, bonusCode: action.payload }
	case PurchaseActionType.FETCH_BUNDLE_ITEMS:
		const loadingBundleItems = { ...state, loadingBundleItems: true }
		return updateLoadingState(loadingBundleItems)
	case PurchaseActionType.RECEIVE_BUNDLE_ITEMS:
		const itemsByNameId = _keyBy(action.payload.items, 'nameId')
		const loadedBundleItems = { ...state, bundleItems: itemsByNameId, loadingBundleItems: false }
		return updateLoadingState(loadedBundleItems)
	case PurchaseActionType.HAS_MADE_PURCHASES:
		return { ...state, hasMadePurchases: action.payload }
	case PurchaseActionType.SET_PURCHASE_SOURCE:
		return { ...state, source: action.payload }
	default:
		// Assert never is used to ensure that every known purchase action is handled by the switch-case.
		const assertNever: never = action
		return state
	}
}

export function updateLoadingState(state: PurchaseState): PurchaseState {
	return { ...state, loading: state.loadingBundles || state.loadingLimits || state.loadingBundleItems }
}
